<template>
  <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4" @click.self="$emit('close')">
    <div class="w-full max-w-sm rounded-lg bg-surface dark:bg-surface-dark border border-stroke dark:border-stroke-dark shadow-xl">
      <div class="flex items-center justify-between px-4 py-3 border-b border-stroke dark:border-stroke-dark">
        <h2 class="text-sm font-semibold text-fg-base dark:text-fg-base-dark">Keyboard shortcuts</h2>
        <button @click="$emit('close')" class="text-fg-faint dark:text-fg-faint-dark hover:text-fg-secondary dark:hover:text-fg-base-dark">
          <XMarkIcon class="h-4 w-4" />
        </button>
      </div>
      <ul class="px-4 py-2 divide-y divide-stroke dark:divide-stroke-dark">
        <li v-for="s in shortcuts" :key="s.description" class="flex items-center justify-between py-2 text-xs">
          <span class="text-fg-secondary dark:text-fg-secondary-dark">{{ s.description }}</span>
          <kbd class="px-1.5 py-0.5 rounded border border-stroke-strong dark:border-stroke-strong-dark bg-surface-muted dark:bg-surface-hover-dark font-mono text-[11px] text-fg-base dark:text-fg-base-dark">{{ s.keys[0] }}</kbd>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

defineProps({
  shortcuts: { type: Array, required: true },  // [{ keys: [...], description }]
})
const emit = defineEmits(['close'])

const onKeydown = e => { if (e.key === 'Escape') emit('close') }
onMounted(() => document.addEventListener('keydown', onKeydown))
onUnmounted(() => document.removeEventListener('keydown', onKeydown))
</script>
